import React, { Component } from 'react';
import Slider from 'react-slick';
import SliderButton from './slider_button';
import canUseDOM from 'exenv';

class MICApplyCarousel extends Component {
  constructor() {
    super();

    this.state = {
      activeSlide: 0
    };
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      const w = window.innerWidth;
      const m = document.querySelector('.awards-page__main').clientWidth - 80;
      const s = document.querySelector('section.slider .slide').clientWidth;
      const p = window
        .getComputedStyle(document.querySelector('.slick-list'), null)
        .getPropertyValue('padding-left');

      if (w < 1274 && w >= 1024) {
        document.querySelector('section.slider .slick-slide').style.width = m;
        document.querySelector('.slick-list').style.paddingLeft =
          (w - s) / 2 - 20;
        document.querySelector('.slick-list').style.paddingRight =
          (w - s) / 2 - 20;

        document.querySelector('.slick-next').style.right = `${p - 72}px`;
        document.querySelector('.slick-prev').style.left = `${p - 72}px`;
      }
    });
  }

  render() {
    const settings = {
      prevArrow: <SliderButton direction="prev" />,
      nextArrow: <SliderButton direction="next" />,
      arrows: true,
      infinite: true,
      className: 'center',
      centerMode: true,
      centerPadding: '207px',
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      afterChange: current => this.setState({ activeSlide: current })
    };

    const slideData = [
      {
        src:
          'https://images.fastcompany.net/image/upload/v1557501587/fcweb/11-target-FA0319TARG001-horiz-legs_pm5blh.jpg',
        caption:
          "A stool from Target's Project 62 furniture line. [Photo: Jamie Chung]"
      },
      {
        src:
          'https://images.fastcompany.net/image/upload/v1557501587/fcweb/FA0319_STITCHFIX_COVE001_utdz5c.jpg',
        caption:
          'Stitch Fix CEO Katrina Lake. [Photo: Jason Madara; Hair and makeup: Erika Taniguchi at Kern Represents]'
      },
      {
        src:
          'https://images.fastcompany.net/image/upload/v1557501587/fcweb/46-MIC-16-9-FA0319AMMU002_goligt_nlg29z.jpg',
        caption:
          'Recent projects from design firm Ammunition. Clockwise from left: The Ember Ceramic Mug; the Deep Sentinel outdoor camera; the June Oven; the Polaroid Mint; and the Acorns Spend card. [Photo: Jamie Chung]'
      },
      {
        src:
          'https://images.fastcompany.net/image/upload/v1557501588/fcweb/FA0319MOZI001_Mozilla_dqjsfw.jpg',
        caption: 'Mozilla COO Denelle Dixon. [Photo: Jessica Chou]'
      },
      {
        src:
          'https://images.fastcompany.net/image/upload/v1557501588/fcweb/p-1-sweetgreen-most-innovative-companies-2019-MIC-FA0319SWEE001_fya7m5.jpg',
        caption:
          'The Koginut Squash bowl from Sweetgreen. [Photo: Jamie Chung; Food stylist: Ali Nardi at Apostrophe]'
      },
      {
        src:
          'https://images.fastcompany.net/image/upload/v1557501587/fcweb/p-1-goat-most-innovative-companies-2019-FA0319GOAT002_mwhe8n.jpg',
        caption: 'GOAT cofounder and CEO Eddy Lu. [Photo: Glaskew II]'
      },
      {
        src:
          'https://images.fastcompany.net/image/upload/v1557501588/fcweb/p-1-WINC-FA0319WINC001_a0vwgo.jpg',
        caption:
          'The Finke’s Sparkling White Blend from Winc wine club. [Photo: Jamie Chung; Food stylist: Ali Nardi at Apostrophe]'
      },
      {
        src:
          'https://images.fastcompany.net/image/upload/v1557501588/fcweb/p-1-modern-fertility-most-innovative-companies-2019-FA0319MODE001_ow0itz.jpg',
        caption:
          'Modern Fertility cofounders Afton Vechery, left, and Carly Leahy. [Photo: Jessica Chou]'
      },
      {
        src:
          'https://images.fastcompany.net/image/upload/v1557501588/fcweb/p-1-zola-most-innovative-companies-2019-FA0319ZOLA001_kqsr6q.jpg',
        caption:
          'Zola cofounders Shan-Lyn Ma and Nobu Nakaguchi. [Photo: Aaron Richter]'
      }
    ];

    return (
      <section className="slider">
        <div className="slideshow-wrapper">
          <link
            rel="stylesheet"
            href="https://maxcdn.icons8.com/fonts/line-awesome/1.1/css/line-awesome-font-awesome.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            charSet="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
          />

          {canUseDOM && (
            <Slider {...settings}>
              <div className="slide" style={{ width: '860px' }}>
                <img src={slideData[0].src} alt={slideData[0].caption} />
              </div>

              <div className="slide">
                <img src={slideData[1].src} alt={slideData[1].caption} />
              </div>

              <div className="slide">
                <img src={slideData[2].src} alt={slideData[2].caption} />
              </div>

              <div className="slide">
                <img src={slideData[3].src} alt={slideData[3].caption} />
              </div>

              <div className="slide">
                <img src={slideData[4].src} alt={slideData[4].caption} />
              </div>

              <div className="slide">
                <img src={slideData[5].src} alt={slideData[5].caption} />
              </div>

              <div className="slide">
                <img src={slideData[6].src} alt={slideData[6].caption} />
              </div>

              <div className="slide">
                <img src={slideData[7].src} alt={slideData[7].caption} />
              </div>

              <div className="slide">
                <img src={slideData[8].src} alt={slideData[8].caption} />
              </div>
            </Slider>
          )}
        </div>

        <div className="slideshow-caption">
          {slideData[this.state.activeSlide].caption}
        </div>
      </section>
    );
  }
}

export default MICApplyCarousel;
